import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';

import './ChatSubmit.css';

export const ChatSubmit = (props) => {
  const { t } = useTranslation();

  const [msg, setMsg] = useState('');

  return (
    <form onSubmit={(e) => { if (msg !== '') { props.onSubmit(msg); } e.preventDefault(); setMsg('')}}>
      <div className="chatSubmit">
        <input value={msg} onChange={e => setMsg(e.target.value)}/>
        <Button type="submit" disabled={props.disabled || msg === ''}>{t('SEND')}</Button>
      </div>
    </form>
  );
}